export interface SkillWeightSummary {
  name: string
  totalWeight: number
  iconUrl: string | null
}

interface LessonEntryForWeights {
  lesson: {
    lessonToSkillWeights: {
      skillWeightId: string
      value: number
      skillWeight: { name: string; iconUrl: string | null }
    }[]
  }
}

export function getSkillWeights(lessons: LessonEntryForWeights[]): SkillWeightSummary[] {
  const weightMap = new Map<string, SkillWeightSummary>()

  for (const entry of lessons) {
    for (const sw of entry.lesson.lessonToSkillWeights) {
      const existing = weightMap.get(sw.skillWeightId)
      if (existing) {
        existing.totalWeight += sw.value
      } else {
        weightMap.set(sw.skillWeightId, {
          name: sw.skillWeight.name,
          totalWeight: sw.value,
          iconUrl: sw.skillWeight.iconUrl,
        })
      }
    }
  }

  return Array.from(weightMap.values())
}
